import React from "react";
import SectionHeader from "./SectionHeader";
import InputField from "./../common/InputField";

function AccountDataSection() {
  return (
    <section className="mt-6 w-full max-md:max-w-full">
      <SectionHeader icon="lock" title="account data" />
      <div className="mt-4 w-full text-sm leading-loose max-md:max-w-full">
        <div className="flex flex-wrap gap-6 items-start w-full max-md:max-w-full">
          <InputField
            label="E-mail address"
            value="example@gmail.com"
            required
            className="flex-1 shrink basis-0 min-w-60 max-md:max-w-full"
          />
          <InputField
            label="Username"
            value="example@gmail.com"
            required
            className="flex-1 shrink whitespace-nowrap basis-0 min-w-60 max-md:max-w-full"
          />
        </div>
        <InputField
          label="New Password"
          placeholder="New Password"
          type="password"
          className="mt-6 w-full max-md:max-w-full"
        />
        <InputField
          label="Repeat password"
          placeholder="Repeat password"
          type="password"
          className="mt-6 w-full max-md:max-w-full"
        />
      </div>
    </section>
  );
}

export default AccountDataSection;
